import React, {useState} from 'react';
import {T} from '../../../utils/I18n/I18n';
import {useMutation, useQuery, NetworkStatus} from '@apollo/client';
import Loader from '../../../components/Loader';
import {GET_WISHLIST_PRODUCTS, REMOVE_PRODUCT_FROM_WISHLIST} from './wishlistQuery';
import "../../ListingProducts/ListingProducts.scss";
import './PersonalAreaWishlist.scss';
import ReactPaginate from "react-paginate";
import loadable from "@loadable/component";
const Products = loadable(() => import('../../../components/Category/Products/Products'));

const PersonalAreaWishlist = () => {
    const [pagination, setPagination] = useState(12);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [products, setProducts] = useState([]);
    const {loading, data, refetch, networkStatus} = useQuery(GET_WISHLIST_PRODUCTS, {
        variables: {
            pageSize: parseInt(pagination),
            currentPage: parseInt(page)
        },
        fetchPolicy: "no-cache",
        notifyOnNetworkStatusChange: true,
        onCompleted: ((data) => {
            const _products = data.getWishlistProducts.wishlists[0].items_v2.items.map((item) => {
                return item.product
            })
            setProducts(_products)
            setPage(data.getWishlistProducts.wishlists[0].items_v2.page_info.current_page)
            setPages(data.getWishlistProducts.wishlists[0].items_v2.page_info.total_pages)
        })
    });

    const [removeProductsFromWishlist] = useMutation(REMOVE_PRODUCT_FROM_WISHLIST, {
        awaitRefetchQueries: true
    });

    window.addEventListener('wishlist_remove', function(event) {
        refetch();
    });

    const emptyWishlist = !loading && products.length === 0;

    const onPageChange = (page) => {
        setPage(page.selected + 1)
        refetch({
            currentPage: page.selected + 1
        })
    }

    return (
        <div className="wishlist">
            <span className="personal-area-title"><T id="wishlist.myWishlist"/></span>
            {emptyWishlist &&
                <div className="wishlist__no-data">
                    <T id="wishlist.wishlistEmpty"/>
                </div>}

            {(loading || networkStatus === NetworkStatus.refetch) && <Loader height="xxl"/>}

            {products.length > 0 &&
                <>
                    <div className="wishlist__content">
                        <Products items={products}/>
                    </div>
                </>
            }

            {pages>1 && <ReactPaginate
                previousLabel={<div className="pagination__arrow_prev"/>}
                nextLabel={<div className="pagination__arrow_next"/>}
                breakLabel="..."
                forcePage={page - 1}
                pageRangeDisplayed={4}
                marginPagesDisplayed={1}
                pageCount={pages}
                onPageChange={onPageChange}
                breakClassName="pagination__page"
                disabledClassName="disabled"
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                previousClassName="pagination__arrow"
                previousLinkClassName="pagination__arrow-link"
                nextClassName="pagination__arrow"
                nextLinkClassName="pagination__arrow-link"
                pageClassName="pagination__page"
                activeClassName="active-page"
                activeLinkClassName="active-link"
            />}
        </div>
    );
};

export default PersonalAreaWishlist;
